import { SelectTag } from 'shared/ui/select/selectTag';
import { MAIN_COLOR } from 'shared/consts';
import {
	GuestsAndTagsFilters,
	InputTextContainer,
	SelectTagsContainer,
} from '../styles';
import { Flex } from 'shared/ui/flex';
import { Typography, withTypographyContainer } from 'shared/ui/typography';
import { FC } from 'react';
import { InputNumber } from 'shared/ui/Inputs/inputNumber';
import { OrderResourcesGuestsFiltersProps } from '../types';

export const OrderResourcesGuestsFilters: FC<
	OrderResourcesGuestsFiltersProps
> = ({
	guestsCountStart,
	guestsCountEnd,
	resourcesOptions,
	selectedResourcesOptions,
	changeResources,
	changeParticipantsStart,
	changeParticipantsEnd,
}) => {
  const Label = withTypographyContainer(Typography);

	return (
		<GuestsAndTagsFilters>
			<div>
				<Label colorVariant={'main'} isBold={true} whiteSpace="nowrap">
					Количество гостей
				</Label>
				<Flex $gap="5px" $alignItems="center">
					<InputTextContainer>
						<InputNumber
							defaultValue={guestsCountStart}
							onChange={changeParticipantsStart}
						/>
					</InputTextContainer>
					<Typography mode={'large'}>—</Typography>
					<InputTextContainer>
						<InputNumber
							onChange={changeParticipantsEnd}
							defaultValue={guestsCountEnd}
						/>
					</InputTextContainer>
				</Flex>
			</div>
			<SelectTagsContainer>
				<Label colorVariant={'main'} isBold={true}>
					Стол
				</Label>
				<SelectTag
					options={resourcesOptions}
					value={selectedResourcesOptions}
					tagColor={MAIN_COLOR}
					onSelect={changeResources}
					placeholder="Выберите столы"
				/>
			</SelectTagsContainer>
		</GuestsAndTagsFilters>
	);
};
